import script from "./AnexosAprovacaoListaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexosAprovacaoListaPage.vue?vue&type=script&setup=true&lang=js"

import "./AnexosAprovacaoListaPage.vue?vue&type=style&index=0&id=216466c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216466c1"]])

export default __exports__